import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import InstagramIcon from "../../assets/images/instagramIcon.svg";
import LinkedInIcon from "../../assets/images/linkedInIcon.svg";
import YouTubeIcon from "../../assets/images/youtubeIcon.svg";
import TwitterIcon from "../../assets/images/twitterIcon.svg";

import FooterImage from "@/assets/images/footer-image.svg";
import FooterImageMob from "@/assets/images/footer-image-mob.svg";
// import { ROUTESLIST } from "@/static/urls";

//import Subscription from './subscription';
// import FooterMenuColumn from "./menu-column.js";
import "./index.scss";

// const getYear = () => {
//   const now = new Date();
//   return now.getFullYear();
// };
//Domain Knowledge FAQ

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToSignup: false,
      windowWidth: window.innerWidth, // Set initial window width
      token: null,
      isLoggedIn: !!localStorage.getItem("token"),
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize); // Listen for resize events when component mounts
    window.addEventListener("storage", this.handleStorageChange);
    // const token = localStorage.getItem("token");
    // this.setState({ token });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize); // Clean up event listener when component unmounts
    window.removeEventListener("storage", this.handleStorageChange);
  }

  handleResize = () => {
    this.setState({
      windowWidth: window.innerWidth, // Update the window width in state
    });
  };

  handleStorageChange = () => {
    const token = localStorage.getItem("token");
    this.setState({ isLoggedIn: !!token });
  };

  render() {
    // const year = getYear();
    const { redirectToSignup, windowWidth, isLoggedIn } = this.state;
    if (redirectToSignup) {
      return <Redirect to="/signup" />;
    }
    return (
      <div className="page-footer">
        <div className="content-footer">
          <div className="page-footer__wrap">
            <h1 className="page-footer-heading">
              Ample Samples<sup>TM</sup>
            </h1>
            <p className="page-footer-subtitle">
              Clear Your Music and Samples Quickly and Accurately!
            </p>
            <p className="page-footer-subtitle">
              <a
                href="https://theamplesamples.beehiiv.com/"
                target="_blank" rel="noopener noreferrer"
              >Ample Samples Newsletter</a>
            </p>
            {isLoggedIn ? (
              ""
            ) : (
              <button
                className="page-footer-button"
                onClick={() => {
                  this.setState({
                    redirectToSignup: true,
                  });
                }}
              >
                Create account
              </button>
            )}
            {/* <button
              className="page-footer-button"
              onClick={() => {
                this.setState({
                  redirectToSignup: true,
                });
              }}
            >
              Create account
            </button> */}
            <div className="page-footer-social">
              <a
                href="https://www.instagram.com/theamplesamples?igsh=NTc4MTIwNjQ2YQ=="
                target="_blank" rel="noopener noreferrer"
              >
                <img src={InstagramIcon} alt="instagram" />
              </a>
              <a
                href="https://www.linkedin.com/in/ample-samples%E2%84%A2-28b253160?"
                target="_blank" rel="noopener noreferrer"
              >
                <img src={LinkedInIcon} alt="LinkedIn"/>
              </a>
              <a
                href="https://youtube.com/@theamplesamples?si=3m3.3_xHUFBXh_j1V3"
                target="_blank" rel="noopener noreferrer"
              >
                <img src={YouTubeIcon} alt="Youtube"/>
              </a>
              <a href="https://x.com/theamplesamples" target="_blank" rel="noopener noreferrer">
                <img src={TwitterIcon} alt="twitter"/>
              </a>
            </div>
            {/* <FooterMenuColumn classList="page-footer__col" title="OVERVIEW">
                            <ul className="page-footer__links">
                                <li><Link to={ROUTESLIST.CLEAR_SAMPLE}>Music Clearance</Link></li>
                                <li><Link to={ROUTESLIST.STATIC_TERMS}>Terms & Conditions</Link></li>
                                <li><Link to={ROUTESLIST.CLOSED_PAGE + 'corporate-terms-and-conditions'}>Pricing</Link></li>
                                <li><Link to={ROUTESLIST.STATIC_TESTIMONIALS}>Interviews</Link></li>                                
                            </ul>
                        </FooterMenuColumn>
                        <FooterMenuColumn classList="page-footer__col" title="MENU">
                           <ul className="page-footer__links">
                                <li><Link to={ROUTESLIST.HOME}>About us</Link></li>
                                <li><a href="mailto:info@thesampl.es">Contact us</a></li> 
                                <li><a href="https://grooves.theamplesamples.com" target="_blank" rel="noopener noreferrer">Grooves</a></li>
                                <li><Link to={ROUTESLIST.UPLOAD_REVIEW}>Sample Review</Link></li>
                            </ul>         
                        </FooterMenuColumn>
                        <FooterMenuColumn classList="page-footer__col page-footer__col_socials" title="Socials">
                             <ul className="page-footer__links">
                                <li><a href="https://www.youtube.com/channel/UCX83YyEkoLn3RXnV5pnR0Dg" target="_blank" rel="noopener noreferrer">Youtube</a></li>
                                <li><a href="https://twitter.com/theamplesamples" target="_blank" rel="noopener noreferrer">Twitter</a></li>  
                                <li><a href="https://www.instagram.com/theamplesamples/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                                <li><a href="https://www.linkedin.com/in/ample-samples%E2%84%A2-28b253160/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>  
                            </ul>   
                        </FooterMenuColumn> */}
          </div>
          <div className="page-footer__cr">
            {/* Copyright © {year} Ample Samples&trade;. All rights reserved. */}
            Copyright © 2026 Ample Samples&trade;. All rights reserved.
          </div>
          <span className="footer-image">
            <img
              src={windowWidth <= 768 ? FooterImageMob : FooterImage}
              alt="footer logo"
            />
          </span>
        </div>
      </div>
    );
  }
}
